import { extractParagraphsFromContentBlocks } from './extractParagraphsFromContentBlocks';
import type { DocParts } from '../../slate-api';
import { AlineTransforms, isHeaderElement, Queries } from '../../slate-api';
import type { Context, ExtractedParagraph } from '../shared/types';

export function extractParagraphsFromAlineDoc(docParts: DocParts): ExtractedParagraph[] {
  const editor = AlineTransforms.createQueryEditorFromJson(docParts);
  const [[document, documentPath], ...headerFooterEntries] = Queries.getActiveRootEntries(editor);

  const allParagraphs: ExtractedParagraph[] = [];

  // Extract from body (BODY section)
  const bodyContext: Context = {
    cellPath: [],
    listDefinitions: document.listDefinitions,
    path: documentPath,
    section: 'BODY',
  };
  allParagraphs.push(...extractParagraphsFromContentBlocks(document.children, bodyContext));

  // Extract from active headers and footers
  // This is placed after the body.
  // IMPORTANT! Do not move this before the body without adjusting the way
  // that titles are extracted which we start looking for at line 1.
  for (const [rootElement, rootPath] of headerFooterEntries) {
    const section: Context['section'] = isHeaderElement(rootElement) ? 'HEAD' : 'FOOT';

    const context: Context = {
      cellPath: [],
      listDefinitions: document.listDefinitions,
      path: rootPath,
      section,
    };
    allParagraphs.push(...extractParagraphsFromContentBlocks(rootElement.children, context));
  }

  return allParagraphs;
}
